const MAP = {
  present: { text: "text-emerald-700", bg: "bg-emerald-50", border: "border-emerald-200", dot: "bg-emerald-500", label: "Present" },
  late: { text: "text-orange-700", bg: "bg-orange-50", border: "border-orange-200", dot: "bg-orange-500", label: "Late" },
  review: { text: "text-amber-700", bg: "bg-amber-50", border: "border-amber-200", dot: "bg-amber-500", label: "Review" },
  absent: { text: "text-rose-700", bg: "bg-rose-50", border: "border-rose-200", dot: "bg-rose-500", label: "Absent" },
  off_day: { text: "text-indigo-700", bg: "bg-indigo-50", border: "border-indigo-200", dot: "bg-indigo-500", label: "Off Day" },
  pending: { text: "text-slate-500", bg: "bg-slate-100", border: "border-slate-200", dot: "bg-slate-400", label: "Pending" },
  default: { text: "text-slate-600", bg: "bg-slate-100", border: "border-slate-200", dot: "bg-slate-400", label: "—" },
};

export default function StatusBadge({ status, testid }) {
  const key = status && MAP[status] ? status : "default";
  const s = MAP[key];
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center gap-1.5 text-xs font-semibold px-2.5 py-1 rounded-full border ${s.text} ${s.bg} ${s.border}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${s.dot}`} />
      {status ? s.label : "—"}
    </span>
  );
}
